import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AiAssistantTab = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 18 }, forwardedRef) => {
    return (
      <svg
        ref={forwardedRef}
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.59399 3.42877C7.59399 3.11109 7.30468 2.87068 6.99819 2.95423C3.77566 3.83271 1.40649 6.78033 1.40649 10.2813C1.40649 14.4752 4.80633 17.875 9.00024 17.875C12.8274 17.875 15.9933 15.0438 16.5178 11.3615C16.5589 11.0728 16.3269 10.8247 16.0353 10.8247C15.7735 10.8247 15.5576 11.0264 15.5181 11.2852C15.2957 12.7407 14.5975 14.0395 13.5872 15.0181C12.3734 14.1162 10.755 13.5782 9.00024 13.5782C7.24545 13.5782 5.62705 14.1162 4.41327 15.0181C3.17574 13.8195 2.40649 12.1402 2.40649 10.2813C2.40649 7.26487 4.43197 4.72153 7.19703 3.93714C7.42671 3.87198 7.59399 3.66752 7.59399 3.42877ZM5.21126 15.6784C6.28327 16.4324 7.59006 16.875 9.00024 16.875C10.4104 16.875 11.7172 16.4324 12.7892 15.6784C11.786 15 10.4659 14.5782 9.00024 14.5782C7.53462 14.5782 6.2145 15 5.21126 15.6784ZM9.00024 11.6016C10.0789 11.6016 10.9534 10.7272 10.9534 9.64848C10.9534 8.5698 10.0789 7.69535 9.00024 7.69535C7.92156 7.69535 7.04712 8.5698 7.04712 9.64848C7.04712 10.7272 7.92156 11.6016 9.00024 11.6016ZM9.00024 12.6016C10.6312 12.6016 11.9534 11.2794 11.9534 9.64848C11.9534 8.01751 10.6312 6.69535 9.00024 6.69535C7.36928 6.69535 6.04712 8.01751 6.04712 9.64848C6.04712 11.2794 7.36928 12.6016 9.00024 12.6016Z"
          fill={color}
        />
        <path
          d="M12.2515 2.21198L12.375 1.87827L12.4985 2.21198C12.7517 2.89628 13.2912 3.4358 13.9755 3.68902L14.3092 3.8125L13.9755 3.93598C13.2912 4.1892 12.7517 4.72872 12.4985 5.41302L12.375 5.74673L12.2515 5.41302C11.9983 4.72872 11.4588 4.1892 10.7745 3.93598L10.4408 3.8125L10.7745 3.68902C11.4588 3.4358 11.9983 2.89628 12.2515 2.21198Z"
          stroke={color}
        />
        <path
          d="M14.3747 7.1875C14.9999 6.93356 15.4961 6.43742 15.75 5.81221C16.0039 6.43742 16.5001 6.93356 17.1253 7.1875C16.5001 7.44144 16.0039 7.93758 15.75 8.56279C15.4961 7.93758 14.9999 7.44144 14.3747 7.1875Z"
          stroke={color}
        />
      </svg>
    )
  },
)

export default AiAssistantTab
